<ng-container *transloco="let t">
  <section class="section-resume">
    <div class="ui-title">
      <pxw-icon icon="back" (click)="back()"></pxw-icon>
      {{ t('resume.sectionTitle') }}
    </div>

    <div class="grid-products">
      @if (hasRestrictionConflicts()) {
        <pxw-alert type="warning" size="sm" class="restriction-conflict">
          {{ t('resume.restrictionConflict') }}
        </pxw-alert>
      } @else if (hasSelectionViolations()) {
        <pxw-product-restriction-alert
          [violations]="selectionViolations()"
          [actionText]="t('resume.restrictionSelection')"
        />
      }
      <pxw-cart-view
        [cartItems]="cartItems()"
        [readOnly]="false"
        [selectedLanguage]="selectedLanguage()"
        [displaySku]="displaySku()"
        [promotionsByProductId]="participatingPromotionsByProductId()"
        [savingsByProductId]="savingsByProductId()"
        [upsellHintsByCartItemId]="upsellHintsByCartItemId()"
        [categoriesAvailabilityById]="categoriesAvailabilityById()"
        [undefinedGroupName]="t('product.undefinedGroupName')"
        [restrictionLabelByProductId]="restrictionLabelByProductId()"
        (edit)="onEditCartItem($event)"
        (remove)="onRemoveCartItem($event)"
        (removeAll)="onRemoveCartItems($event)"
        (update)="onUpdateCartItem($event)"
      />

      <pxw-modal-dialog
        #removeCartItemDialog
        [title]="
          t('resume.confirmRemoveFromCartTitle', {
            cartItemName: cartItemToRemove()?.product?.name,
          })
        "
        type="confirm"
      >
        <pxw-icon icon="alert" />
        <p>{{ t('resume.confirmRemoveFromCartSubtitle') }}</p>
      </pxw-modal-dialog>
    </div>

    <div class="checkout">
      @if (endOrderTotals(); as totals) {
        <pxw-order-totals-resume
          [endOrderTotals]="totals"
          [totalLabel]="t('global.total')"
          [viewDetailsLabel]="t('endOrder.totalAmountViewDetails')"
          [confirmOrderText]="
            !isCartDisabled()
              ? hasMinimumPurchaseError()
                ? t('resume.minimumPurchaseAmountText', { minimumPurchase: minimumPurchase() })
                : t('resume.confirmOrderText')
              : undefined
          "
          [disabled]="disableConfirmOrder()"
          [saving]="loadingCheckout()"
          (confirmOrder)="goToEndOrder()"
        />
      }
      @if (isCartDisabled()) {
        <pxw-alert type="warning" size="sm" (click)="displayWorkingHours($event)">
          {{ t('global.cartDisabledWhileClosed') }}
        </pxw-alert>
      }
      @if (repeatOrderRemovedNames) {
        <pxw-alert type="warning" size="sm">
          {{ t('resume.repeatOrderItemsUnavailable', { products: repeatOrderRemovedNames }) }}
        </pxw-alert>
      }
    </div>
  </section>
</ng-container>
